import { NotificationManager } from 'react-notifications';
import { SERVER_API } from "../../../config.json";
import Cookies from 'universal-cookie';
const cookies = new Cookies();
let tokenUser = cookies.get('usercode');
 function tokenAPI()
 {
	 if(tokenUser.token)
	 {
		 return tokenUser.token;
	 }
	 else{
		 NotificationManager.error('Mời bạn đăng nhập lại');
	 }
 }
let DataTest = [
    {
        ID: 1,
        Task: "Task1",
    },
    {
        ID: 2,
        Task: "Task2",
    },
    {
        ID: 3,
        Task: "Task3",
    },
    {
        ID: 4,
        Task: "Task4",
    },
    {
        ID: 5,
        Task: "Task5",
    },
];
//Main
function* GetDataMenuFromApi() {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/Menu/GetMenu", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify({"UserCode": cookies.get('usercode').userCode ? cookies.get('usercode').userCode : "",
        "Type": 4
        })
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        return yield Data.data;
    }
    return yield {};
}
//GetUsersID
function* GetDataUserFromApi() {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/User/GetuserID", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        }
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        return yield Data.data;
    }
    return yield {};
}
function* SetDataMenuFromApi(DataMain) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/Menu/InsertMenu", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataMain),
    });
    const Data = yield response.json();
    if (Data.status === "OK") {        
        console.log(Data.data);
        if (Data.data[0].id === 1) {
            NotificationManager.error("Đã tồn tại menu!");
        }
        else{            
            NotificationManager.success("Thêm thành công");
        }
        return yield Data.data;
    }
    return yield {};
}
//SetPermission
function* SetDataPermission(DataMain) {
    var test = tokenAPI();
    console.log("SetDataPermission",DataMain);
    const response = yield fetch(SERVER_API + "api/Menu/PermissionMenu", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataMain),
    });
    const Data = yield response.json();
    if (Data.status === "OK") {        
        NotificationManager.success("Lưu thành công");
    }
    else{
        NotificationManager.error("Lưu thất bại");
    }
    return yield DataTest;
}
//CreateFuntionHygen
export const Api = {
    GetDataMenuFromApi,
    SetDataMenuFromApi,
    GetDataUserFromApi,
    SetDataPermission
    //ExportFuntionHygen
}